import { ChangeEventHandler, memo } from "react";
import * as input from "./input.module.css";

export const TextInput = memo(
  ({
    ...rest
  }: {
    placeholder?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
  }) => {
    return <input className={input.text} {...rest} />;
  },
);

export enum InputSize {
  SMALL,
  MEDIUM,
  LARGE,
}
